import api from './api';

const reportService = {
  getAllReports: async (filters = {}) => {
    const params = new URLSearchParams(filters);
    const response = await api.get(`/reports?${params}`);
    return response.data;
  },

  getReportById: async (id) => {
    const response = await api.get(`/reports/${id}`);
    return response.data;
  },

  createReport: async (reportData) => {
    const response = await api.post('/reports', reportData);
    return response.data;
  },

  updateReport: async (id, reportData) => {
    const response = await api.put(`/reports/${id}`, reportData);
    return response.data;
  },

  deleteReport: async (id) => {
    const response = await api.delete(`/reports/${id}`);
    return response.data;
  },

  getReportsByPlayer: async (playerId) => {
    const response = await api.get(`/reports/player/${playerId}`);
    return response.data;
  },

  submitReport: async (id) => {
    const response = await api.put(`/reports/${id}/submit`);
    return response.data;
  }
};

export default reportService;
